import { render, staticRenderFns } from "./AddPaqueteDeclaraFoliosModal.vue?vue&type=template&id=556076f6"
import script from "./AddPaqueteDeclaraFoliosModal.vue?vue&type=script&lang=js"
export * from "./AddPaqueteDeclaraFoliosModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('556076f6')) {
      api.createRecord('556076f6', component.options)
    } else {
      api.reload('556076f6', component.options)
    }
    module.hot.accept("./AddPaqueteDeclaraFoliosModal.vue?vue&type=template&id=556076f6", function () {
      api.rerender('556076f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/modal/AddPaqueteDeclaraFoliosModal.vue"
export default component.exports